module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado14.447e4fa8.svg";